import React, { useEffect, useState, useCallback } from "react";
import Header from "../../components/Header/Header";
import { Icons, Images, } from "../../assets/assets";
import Footer from "../../components/Footer/Footer";
import { BsImages, BsPlayCircleFill } from "react-icons/bs";
import { RoundedCircleComponent } from "../SparklingWaterMaker/SparklingWaterMaker";
import SecondaryButton from "../../components/Button/SecondaryButton";
import RecommendationItem from "../../components/RecommendationItem/RecommendationItem";
import ProductInfoPanel from "../../components/ProductInfoPanel/ProductInfoPanel";
import { IComment } from "../../@types/productInfo";
import Breadcrumb from "../../components/Breadcrumb/Breadcrumb";
import PlainVideo from "../../components/VideoPreview/PlainVideo";
import { DefaultCarousel } from "../../components/ImgCarousel/Carousel";
import { Link, useParams } from "react-router-dom";
import waterMachineServiceInstance from "../../APIs/watermachines";
import Loading from "../../components/Loading/Loading";
import { Helmet } from "react-helmet";
import { useCart } from "../../components/CartContext/CartContext";
import { useNotification } from "../../components/Toast/Notification";
import CartModal from "../../components/ModalImtemAdded/ModalItemAdded";
import faqServiceInstance, { } from "../../APIs/faq";
import { Eye, ShoppingCart } from "lucide-react";

// TODO: change them
const recommendations = [
  { image: Images.ArtStep1, title: "Quick Connect" },
  { image: Images.ArtStep2, title: "Click" },
  { image: Images.ArtStep3, title: "Fizz" },
  { image: Images.ArtStep4, title: "Enjoy" },
];
const recommendationsEnso = [
  { image: Images.EnsoStep1, title: "CO2 cylinder quick connect system" },
  {
    image: Images.EnsoStep2,
    title: "Elegantly crafted from high-quality stainless steel",
  },
  {
    image: Images.EnsStep3,
    title: "Stainless steel carbonation nozzle for optimal hygiene",
  },
  {
    image: Images.EnsStep4,
    title: "Stainless steel drip tray for easy maintenance",
  },
];

const recommendationsGaia = [
  { image: Images.GaiaStep1, title: "QUICK CONNECT" },
  { image: Images.GaiaStep2, title: "FILL" },
  { image: Images.GaiaStep3, title: "MAKE IT SPARKLE" },
  { image: Images.GaiaStep4, title: "ENJOY!" },
];

const whyEnsoItems = [
  "Iconic design – Elegant sparkling water maker designed by the globally renowned Naoto Fukasawa, perfect to elevate your kitchen decor.",
  "Crafted from high-quality stainless steel – Combines premium materials with a minimalistic style for a sophisticated look.",
  "Snap & Lock technology – Easily secures the carbonating bottle without twisting, ensuring a safe and comfortable experience.",
  "Slide-in CO2 cylinder compartment – Simplifies CO2 installation with a user-friendly design.",
  "Quick Connect system – Insert your CO2 cylinder effortlessly thanks to the patent-pending Quick Connect mechanism.",
  "Dishwasher-safe bottle with removable base – Hassle-free cleaning with a dishwasher-safe bottle.",
  "Cordless – Use it freely anywhere in your kitchen without worrying about cables.",
];

const whyARTItems = [
  "Sleek and stylish retro design with empowering carbonating lever for a unique experience",
  "Premium, stainless-steel trim",
  "Dishwasher safe, BPA free, reusable bottles",
  "Cordless and compact design to fit every kitchen",
  'Quick Connect C02 cylinder: for fast, "one click" cylinder insertion makes up to 60L * of sparkling water * depending on the degree of carbonation.',
];

const whyGAIAItems = [
  "Simple & basic sparkling water maker – Perfect for everyday use with easy operation.",
  "Includes 1L BPA-free, dishwasher-safe carbonating bottle – Clean and reuse effortlessly.",
  "Manual carbonation – No electricity required, ideal for any setup.",
  "Patented Quick Connect system – Easily attach the CO₂ cylinder with a simple, intuitive connection.",
  "Twist-in bottle installation – Securely fasten your bottle with a quick twist.",
  "Cordless – Use anywhere in your kitchen without being limited by plugs or outlets.",
  "Each kit includes: GAIA sparkling water maker, 1 CO₂ Quick Connect cylinder (carbonates up to 60L), and 1 BPA-free bottle.",
  "A healthier, planet-friendly alternative to bottled drinks – Enjoy sparkling water at the push of a button.",
];

const whyTerraItems = [
  "The best way to make fresh sparkling water and more user-friendly than ever",
  "Dishwasher-safe, BPA-free, reusable bottles",
  "Compact and sleek with a wider carbonating button",
  'NEW Quick Connect CO2 technology for fast "one click" cylinder insertion',
];

const comments: IComment[] = [
  {
    name: "Martin",
    isVerified: true,
    rating: 4,
    date: "2023-08-24",
    message:
      "Excellent replacement for my now retired SodaStream. I am looking forward to many happy PSSSST moments during the summer days ahead.",
    numLikes: 2,
    numDislikes: 1,
  },
  {
    name: "Darren",
    isVerified: true,
    rating: 5,
    date: "2022-04-18",
    message: `This is one of the few items I could recommend for every kitchen or office anywhere. Great quality product. Very easy to set up and use.  
        Makes sparkling water in seconds and with the large syrups range, you are able to have a decent sparkling beverage in seconds. 
        Also, the cylinders can be swapped out at Pick n Pay, which makes the product very affordable and easy to replace the CO2 canisters when depleted`,
    numLikes: 0,
    numDislikes: 0,
  },
];

const WaterMakerProductPage = () => {
  const [addedProduct, setAddedProduct] = useState<any>();
  const [selectedproductColor, setSelectedProductColor] = useState<any>();
  const [isInCart, setIsInCart] = useState<boolean>(false);
  const [stockLoading, setStockLoading] = useState<boolean>(true);
  const { addToCart } = useCart();

  const [isCartModalVisible, setIsCartModalVisible] = useState(false);

  const { notify } = useNotification();
  const [color, setColor] = React.useState("white");
  const [selectedView, setSelectedView] = React.useState("images");
  const {
    cart,
    availableStock,
    getItemStock,
    handleIncrease,
    handleDecrease,
    isUpdating,
    isDecreasing,
  } = useCart();

  const [isBlack, setIsBlack] = useState<boolean>(false);
  const [selectedProduct, setSelectedProduct] = useState<any>();
  const breadcrumbItems = [
    { text: "Home", href: "/water-makers" },
    { text: "Sparkling Water Makers", href: "/water-makers" },
    { text: selectedProduct ? selectedProduct.name : "Loading..." },
  ];

  const { machinelink } = useParams();
  const encodedUrl = machinelink ? machinelink.replace(/-/g, " ") : "";
// 
  const fetchProductBySku = useCallback(async () => {
    try {
      if (selectedProduct) {
        let sku;

        if (selectedProduct.name === "Art") {
          sku = isBlack ? "266017" : "266016";
        } else if (selectedProduct.name === "Terra") {
          sku = isBlack ? "266015" : "266014";
        } else if (selectedProduct.name === "ensō™") {
          sku = "266035";
        } else if (selectedProduct.name === "GAIA") {
          sku = "266034";
        } else {
  
          return;
        }

        const { data, error } =
          await waterMachineServiceInstance.getWaterMachineBySku(sku);

        if (data) {
          setSelectedProductColor(data);
          setSelectedCategoryId(data.categoryid);
         

          if (data.sku) {
            getItemStock(data.sku);
            setStockLoading(false);
          }
        } else {
          console.error(
            `Error fetching product ${selectedProduct.name} by SKU ${sku}:`,
            error
          );
        }
      } else {

      }
    } catch (error) {
      console.error("Error in fetchProductBySku:", error);
    }
  }, [getItemStock, isBlack, selectedProduct]);

  const fetchProductById = useCallback(async (productlinkname: string) => {
    try {
      const { data, error } =
        await waterMachineServiceInstance.getWaterMachineByLink(
          productlinkname
        );
      if (data) {
        setSelectedProduct(data);
        setSelectedCategoryId(data.categoryid);
      } else {
        console.error("Error fetching product by ID:", error);
      }
    } catch (error) {
      console.error("Error fetching product by ID:", error);
    }
  }, []);

  useEffect(() => {
    fetchProductBySku();
  }, [isBlack, fetchProductBySku]);

  useEffect(() => {
    if (encodedUrl) {
      fetchProductById(encodedUrl);
    }
  }, [encodedUrl, fetchProductById]);

  const capitalizeFirstLetter = (str: string) => {
    return str.replace(/\b\w/g, (char) => char.toUpperCase());
  };

  function toUrlSlug(text: string) {
    const decoded = decodeURIComponent(text);
    const hyphenated = decoded.replace(/\s+/g, "-");
    return hyphenated;
  }

  const checkIfInCart = useCallback(() => {
    if (!selectedproductColor || !cart || !Array.isArray(cart)) return false;

    const productInCart = cart.find(
      (item: any) =>
        item.sku === selectedproductColor.sku ||
        item.id === selectedproductColor.id
    );

    if (productInCart) {
      setAddedProduct(productInCart);
      setSelectedProductColor(productInCart);
      return true;
    }

    return false;
  }, [selectedproductColor, cart]);

  useEffect(() => {
    setIsInCart(checkIfInCart());
  }, [cart, checkIfInCart]);

  const handleAddToCart = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    if (isInCart && addedProduct) {
      setIsCartModalVisible(true);
      return;
    }

    try {
      if (selectedproductColor) {
        const productToAdd = {
          ...selectedproductColor,
          product_type: selectedproductColor.product_type || "",
          name: selectedproductColor.name,
          image: selectedproductColor.image,
          price: selectedproductColor.price,
          sku: selectedproductColor.sku,
          item_quantity: selectedproductColor?.item_quantity,
          is_black: isBlack,
          is_machine: true,
        };

        setAddedProduct(productToAdd);
        addToCart(productToAdd, 1);

        notify(`${selectedProduct.name} successfully added to cart`, "success");
        setIsCartModalVisible(true);
        setIsInCart(true);
      } else {
        throw new Error("Product is undefined");
      }
    } catch (error) {
      notify("Failed to add product to cart", "error");
      console.error("Error adding to cart:", error);
    }
  };

  const [faqs, setFaqs] = useState<any[]>([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState<any>();
  const fetchFaqByCategory = async (category_id: number) => {
    try {
      const { data, error } = await faqServiceInstance.getFaqsByCategory(
        category_id
      );

      if (data) {
        setFaqs(data);


      } else {
        console.error("Error fetching FAQs:", error);
      }
    } catch (error) {
      console.error("Error fetching FAQs:", error);
    }
  };

  useEffect(() => {
    const id = parseInt(selectedCategoryId, 10);

    if (!isNaN(id)) {
      fetchFaqByCategory(id);
    } else {
      console.error("Invalid category ID:", selectedCategoryId);
    }
  }, [selectedCategoryId]);

  const handleProductIncrease = () => {
    // setIsIncreasing(true);
    if (selectedproductColor || addedProduct) {
      handleIncrease(selectedproductColor);
    }
    // setIsIncreasing(false);
  };

  const handleProductDecrease = () => {
    if (selectedproductColor || addedProduct) {
      handleDecrease(selectedproductColor);
    }
  };

  return (
    <div>
      {selectedProduct ? (
        <div>
          <Helmet>
            <meta charSet="utf-8" />
            <title>{selectedProduct.meta_title}</title>
            <meta
              name="description"
              content={selectedProduct.meta_description}
            />
            <link
              rel="canonical"
              href={`https://www.sodastream.co.za/${toUrlSlug(
                selectedProduct.machinelink
              )}`}
            />
          </Helmet>
          <Header
            desktopHeight="450px"
            mobileHeight="auto"
            mobileTextMargin="-32%"
            mobileTitleMargin="25%"
            title={
              capitalizeFirstLetter(selectedProduct.name) === "Art"
                ? "Art Sparkling Water Maker"
                : capitalizeFirstLetter(selectedProduct.name) === "Terra"
                ? "Terra Sparkling Water Maker"
                : selectedProduct.name === "ensō™"
                ? "ensō™ Sparkling Water Maker"
                : selectedProduct.name === "GAIA"
                ? "GAIA Sparkling Water Maker"
                : ""
            }
            backgroundImg={
              selectedProduct?.sku === "266021"
                ? "http://res.cloudinary.com/brabenjos/image/upload/v1748344526/sodastream/1748344526593.jpg"
                : selectedProduct?.sku === "266020"
                ? "http://res.cloudinary.com/brabenjos/image/upload/v1748343983/sodastream/1748343982280.jpg"
                : "http://res.cloudinary.com/brabenjos/image/upload/v1743206423/sodastream/1743206423200.jpg"
            }
            textBackground="WATER MAKERS"
          />

          {selectedProduct.sku === "266034" && (
            <section className="">
              <div className="bg-[#FFFFFF] text-start md:px-20 px-10 py-10 md:py-0">
                <Breadcrumb items={breadcrumbItems} />
              </div>
              <div className="flex flex-col md:flex-row md:gap-0 gap-5">
                <div className="basis-[50%] md:px-20 px-10 text-start">
                  <div className="flex gap-4 items-center">
                    <div className="flex flex-col gap-4">
                      <div
                        onClick={() => setSelectedView("images")}
                        className="p-4 rounded-full bg-[#75A7AD]"
                        style={{
                          boxShadow: "0px 3px 6px #00000029",
                          backgroundColor:
                            selectedView === "images" ? "#75A7AD" : "#FFFFFF",
                        }}>
                        <BsImages
                          fontSize={25}
                          color={selectedView === "images" ? "white" : "black"}
                        />
                      </div>
                      <div className="flex flex-col items-center gap-1">
                        <div
                          onClick={() => setSelectedView("video")}
                          className={`p-4 rounded-full transition-all duration-300 ${
                            selectedView === "video"
                              ? "bg-[#75A7AD] shadow-lg"
                              : "bg-white shadow hover:ring-2 hover:ring-[#75A7AD]"
                          }`}>
                          <BsPlayCircleFill
                            fontSize={25}
                            color={selectedView === "video" ? "white" : "black"}
                          />
                        </div>
                        <span
                          className={`text-xs font-medium ${
                            selectedView === "video"
                              ? "text-[#75A7AD]"
                              : "text-gray-500"
                          }`}>
                          {/* Vido */}
                        </span>
                      </div>

                      {/* <div
                        onClick={() => setSelectedView("video")}
                        className="p-4 rounded-full bg-[#FFFFFF]"
                        style={{
                          boxShadow: "0px 3px 6px #00000029",
                          backgroundColor:
                            selectedView === "video" ? "#75A7AD" : "#FFFFFF",
                        }}>
                        <BsPlayCircleFill
                          fontSize={25}
                          color={selectedView === "video" ? "white" : "black"}
                        />
                      </div> */}
                    </div>
                    <div className="w-full ">
                      {selectedView === "images" ? (
                        <DefaultCarousel
                          images={
                            color === "black"
                              ? selectedProduct.images_black
                              : selectedProduct.images_white
                          }
                        />
                      ) : (
                        <PlainVideo
                          height="420"
                          video={selectedProduct.video || ""}
                        />
                      )}
                      {/* <p className='text-[#005D6E] text-extrabold text-center'>1 out of 6</p> */}
                    </div>
                  </div>
                </div>
                <div
                  className="basis-[50%] text-start md:px-20 px-10 
                flex flex-col gap-4 text-[#005D6E]">
                  <h2 className="text-[30px] font-bold">
                    {capitalizeFirstLetter(selectedProduct.name)}
                  </h2>

                  <h2 className="text-[30px] font-bold">
                    R {selectedProduct.price}
                  </h2>
                  <p className="text-[rgb(0,93,110)] text-[14px] mb-[15px] italic">
                    * Price includes VAT
                  </p>

                  <p className="text-[16px] font-light">
                    {selectedProduct.description}
                  </p>

                  <section className=" gap-2 p-2 flex flex-col md:flex-row py-5">
                    <form className="w-full">
                      {stockLoading ? (
                        <div className="mt-[-10%] inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-[#31526B] text-white">
                          <div className="w-2 h-2 rounded-full bg-white mr-1.5 animate-pulse"></div>
                          Checking stock...
                        </div>
                      ) : (
                        <div
                          className={`inline-flex mb-[15px]  items-center px-2.5 py-1 rounded-full text-xs font-medium ${
                            (availableStock || 0) > 0
                              ? "bg-green-100 text-green-800"
                              : "bg-red-100 text-red-800"
                          }`}>
                          {(availableStock || 0) > 0 ? (
                            <>
                              <span className="w-2 h-2 rounded-full bg-green-500 mr-1.5"></span>{" "}
                              In Stock
                            </>
                          ) : (
                            <>
                              <span className="w-2 h-2 rounded-full bg-red-500 mr-1.5"></span>{" "}
                              Out of Stock
                            </>
                          )}
                        </div>
                      )}
                      <section className="flex md:flex-row flex-col">
                        {(availableStock || 0) <= 0 ? (
                          <Link to="/store-locator">
                            <SecondaryButton
                              className=""
                              label={"Store Locator"}
                            />
                          </Link>
                        ) : (
                          <SecondaryButton
                            label={isInCart ? "View Cart" : "Add to Cart"}
                            onClick={handleAddToCart}
                            icon={isInCart ? <Eye /> : <ShoppingCart />}
                            className=""
                          />
                        )}
                      </section>
                    </form>
                  </section>
                  <div className="flex gap-2 justify-start">
                    <div className="flex flex-col gap-2 text-center items-center basis-[20%]">
                      <img
                        src={
                          "http://res.cloudinary.com/brabenjos/image/upload/v1729853659/sodastream/1729853659431.png"
                        }
                        alt="bottle"
                        style={{ width: "35%" }}
                      />
                      <span className="text-[10px]">
                        Delivered to your door ​
                      </span>
                    </div>

                    <div className="flex flex-col gap-2 text-center items-center basis-[20%]">
                      <img
                        src={Icons.IconCertification}
                        alt="bottle"
                        style={{ width: "35%" }}
                      />
                      <span className="text-[10px]">
                        2 years warranty exclusive to{" "}
                        <Link to={"https://www.sodastream.co.za/"}>
                          Sodastream
                        </Link>
                      </span>
                    </div>
                    <div className="flex flex-col gap-2 text-center items-center basis-[20%]">
                      <img
                        src={Icons.IconCall}
                        alt="bottle"
                        style={{ width: "35%" }}
                      />
                      <span className="text-[10px]">
                        Exceptional Customer Service
                      </span>
                    </div>
                  </div>

                  <div>
                    <p className="font-semibold mt-4">Included in box</p>

                    <div
                      className="rounded-2xl mt-5 overflow-hidden"
                      style={{ boxShadow: "0px 7px 20px #0000001A" }}>
                      <div className="flex border">
                        <div className="basis-[100%] bg-[#EEEAE5] px-10 py-5">
                          <h2 className="text-[24px] font-bold">Starter Kit</h2>
                          {/* <span>Rxxxx.xx Rxxxx.xx</span> */}
                        </div>
                      </div>

                      <div className="grid md:grid-cols-2 grid-cols-1 gap-4 text-[12px] px-10 py-4">
                        <div className="flex gap-2 items-center justify-start">
                          <span className="bg-[#005D6E] text-white px-2 py-1 text-[10px] rounded-full flex items-center justify-center">
                            1X
                          </span>
                          <span>
                            {selectedProduct.name} Sparkling Water Maker
                          </span>
                        </div>
                        <div className="flex gap-2 items-center justify-start">
                          <span className="bg-[#005D6E] text-white px-2 py-1 text-[10px] rounded-full flex items-center justify-center">
                            1X
                          </span>
                          <span>Quick Connect CO2 cylinder</span>
                        </div>
                        <div className="flex gap-2 items-center justify-start">
                          <span className="bg-[#005D6E] text-white px-2 py-1 text-[10px] rounded-full flex items-center justify-center">
                            1X
                          </span>
                          <span>1L Dishwasher Safe, PET bottle</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-5">
                    {/* <SecondaryButton label='Find it in-store' /> */}
                  </div>
                </div>
              </div>

              {/* Recommendations stuff */}
              <div className="hidden md:flex  md:px-20 px-10 py-10 gap-4 md:flex-row flex-col">
                {recommendationsGaia.map((recommendation, index) => (
                  <RecommendationItem
                    key={index}
                    image={recommendation.image}
                    title={recommendation.title}
                  />
                ))}
              </div>

              <div className="md:px-20 px-10 pb-10 pt-5 flex gap-4 md:gap-20 items-center justify-center">
                <div className="flex flex-col gap-2 items-center">
                  <img
                    src={Icons.IconFreshWater}
                    alt="bg"
                    style={{ width: "70%" }}
                  />
                  <span className="text-[14px] text-[#005D6E] font-bold">
                    Stay hydrated
                  </span>
                </div>
                <div className="flex flex-col gap-2 items-center">
                  <img
                    src={Icons.IconHeathier}
                    alt="bg"
                    style={{ width: "70%" }}
                  />
                  <span className="text-[14px] text-[#005D6E] font-bold">
                    Limitless taste
                  </span>
                </div>
                <div className="flex flex-col gap-2 items-center">
                  <img
                    src={Icons.IconSustainability}
                    alt="bg"
                    style={{ width: "70%" }}
                  />
                  <span className="text-[14px] text-[#005D6E] font-bold">
                    Save the planet
                  </span>
                </div>
              </div>
              <ProductInfoPanel
                sections={faqs || []}
                comments={comments}
                specifications={{ title: "Why GAIA?", items: whyGAIAItems }}
              />
            </section>
          )}

          {selectedProduct.sku === "266035" && (
            <section className="">
              <div className="bg-[#FFFFFF] text-start md:px-20 px-10 py-10 md:py-0">
                <Breadcrumb items={breadcrumbItems} />
              </div>
              <div className="flex flex-col md:flex-row md:gap-0 gap-5">
                <div className="basis-[50%] md:px-20 px-10 text-start">
                  <div className="flex gap-4 items-center">
                    <div className="flex flex-col gap-4">
                      <div
                        onClick={() => setSelectedView("images")}
                        className="p-4 rounded-full bg-[#75A7AD]"
                        style={{
                          boxShadow: "0px 3px 6px #00000029",
                          backgroundColor:
                            selectedView === "images" ? "#75A7AD" : "#FFFFFF",
                        }}>
                        <BsImages
                          fontSize={25}
                          color={selectedView === "images" ? "white" : "black"}
                        />
                      </div>
                      <div
                        onClick={() => setSelectedView("video")}
                        className="p-4 rounded-full bg-[#FFFFFF]"
                        style={{
                          boxShadow: "0px 3px 6px #00000029",
                          backgroundColor:
                            selectedView === "video" ? "#75A7AD" : "#FFFFFF",
                        }}>
                        <BsPlayCircleFill
                          fontSize={25}
                          color={selectedView === "video" ? "white" : "black"}
                        />
                      </div>
                    </div>
                    <div className="w-full ">
                      {selectedView === "images" ? (
                        <DefaultCarousel
                          images={
                            color === "black"
                              ? selectedProduct.images_black
                              : selectedProduct.images_white
                          }
                        />
                      ) : (
                        <PlainVideo
                          height="420"
                          video={selectedProduct.video || ""}
                        />
                      )}
                      {/* <p className='text-[#005D6E] text-extrabold text-center'>1 out of 6</p> */}
                    </div>
                  </div>
                </div>
                <div
                  className="basis-[50%] text-start md:px-20 px-10 
                flex flex-col gap-4 text-[#005D6E]">
                  <h2 className="text-[30px] font-bold">
                    {selectedProduct.name}
                  </h2>

                  <h2 className="text-[30px] font-bold">
                    R {selectedProduct.price}
                  </h2>
                  <p className="text-[rgb(0,93,110)] text-[14px] mb-[15px] italic">
                    * Price includes VAT
                  </p>

                  <p className="text-[16px] font-light">
                    {selectedProduct.description}
                  </p>

                  <section className=" gap-2 p-2 flex flex-col md:flex-row py-5">
                    <form className="w-full">
                      {stockLoading ? (
                        <div className="mt-[-10%] inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-[#31526B] text-white">
                          <div className="w-2 h-2 rounded-full bg-white mr-1.5 animate-pulse"></div>
                          Checking stock...
                        </div>
                      ) : (
                        <div
                          className={`inline-flex mb-[15px]  items-center px-2.5 py-1 rounded-full text-xs font-medium ${
                            (availableStock || 0) > 0
                              ? "bg-green-100 text-green-800"
                              : "bg-red-100 text-red-800"
                          }`}>
                          {(availableStock || 0) > 0 ? (
                            <>
                              <span className="w-2 h-2 rounded-full bg-green-500 mr-1.5"></span>{" "}
                              In Stock
                            </>
                          ) : (
                            <>
                              <span className="w-2 h-2 rounded-full bg-red-500 mr-1.5"></span>{" "}
                              Out of Stock
                            </>
                          )}
                        </div>
                      )}
                      <section className="flex md:flex-row flex-col">
                        {(availableStock || 0) <= 0 ? (
                          <Link to="/store-locator">
                            <SecondaryButton
                              className=""
                              label={"Store Locator"}
                            />
                          </Link>
                        ) : (
                          <SecondaryButton
                            label={isInCart ? "View Cart" : "Add to Cart"}
                            onClick={handleAddToCart}
                            icon={isInCart ? <Eye /> : <ShoppingCart />}
                            className=""
                          />
                        )}
                      </section>
                    </form>
                  </section>
                  <div className="flex gap-2 justify-start">
                    <div className="flex flex-col gap-2 text-center items-center basis-[20%]">
                      <img
                        src={
                          "http://res.cloudinary.com/brabenjos/image/upload/v1729853659/sodastream/1729853659431.png"
                        }
                        alt="bottle"
                        style={{ width: "35%" }}
                      />
                      <span className="text-[10px]">
                        Delivered to your door ​
                      </span>
                    </div>

                    <div className="flex flex-col gap-2 text-center items-center basis-[20%]">
                      <img
                        src={Icons.IconCertification}
                        alt="bottle"
                        style={{ width: "35%" }}
                      />
                      <span className="text-[10px]">
                        2 years warranty exclusive to{" "}
                        <Link to={"https://www.sodastream.co.za/"}>
                          Sodastream
                        </Link>
                      </span>
                    </div>
                    <div className="flex flex-col gap-2 text-center items-center basis-[20%]">
                      <img
                        src={Icons.IconCall}
                        alt="bottle"
                        style={{ width: "35%" }}
                      />
                      <span className="text-[10px]">
                        Exceptional Customer Service
                      </span>
                    </div>
                  </div>

                  <div>
                    <p className="font-semibold mt-4">Included in box</p>

                    <div
                      className="rounded-2xl mt-5 overflow-hidden"
                      style={{ boxShadow: "0px 7px 20px #0000001A" }}>
                      <div className="flex border">
                        <div className="basis-[100%] bg-[#EEEAE5] px-10 py-5">
                          <h2 className="text-[24px] font-bold">Starter Kit</h2>
                          {/* <span>Rxxxx.xx Rxxxx.xx</span> */}
                        </div>
                      </div>

                      <div className="grid md:grid-cols-2 grid-cols-1 gap-4 text-[12px] px-10 py-4">
                        <div className="flex gap-2 items-center justify-start">
                          <span className="bg-[#005D6E] text-white px-2 py-1 text-[10px] rounded-full flex items-center justify-center">
                            1X
                          </span>
                          <span>
                            {selectedProduct.name} Sparkling Water Maker
                          </span>
                        </div>
                        <div className="flex gap-2 items-center justify-start">
                          <span className="bg-[#005D6E] text-white px-2 py-1 text-[10px] rounded-full flex items-center justify-center">
                            1X
                          </span>
                          <span>Quick Connect CO2 cylinder</span>
                        </div>
                        <div className="flex gap-2 items-center justify-start">
                          <span className="bg-[#005D6E] text-white px-2 py-1 text-[10px] rounded-full flex items-center justify-center">
                            1X
                          </span>
                          <span>1L Dishwasher Safe, PET bottle</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-5">
                    {/* <SecondaryButton label='Find it in-store' /> */}
                  </div>
                </div>
              </div>

              {/* Recommendations stuff */}
              <div className="hidden md:flex  md:px-20 px-10 py-10 gap-4 md:flex-row flex-col">
                {recommendationsEnso.map((recommendation, index) => (
                  <RecommendationItem
                    key={index}
                    image={recommendation.image}
                    title={recommendation.title}
                  />
                ))}
              </div>

              <div className="md:px-20 px-10 pb-10 pt-5 flex gap-4 md:gap-20 items-center justify-center">
                <div className="flex flex-col gap-2 items-center">
                  <img
                    src={Icons.IconFreshWater}
                    alt="bg"
                    style={{ width: "70%" }}
                  />
                  <span className="text-[14px] text-[#005D6E] font-bold">
                    Stay hydrated
                  </span>
                </div>
                <div className="flex flex-col gap-2 items-center">
                  <img
                    src={Icons.IconHeathier}
                    alt="bg"
                    style={{ width: "70%" }}
                  />
                  <span className="text-[14px] text-[#005D6E] font-bold">
                    Limitless taste
                  </span>
                </div>
                <div className="flex flex-col gap-2 items-center">
                  <img
                    src={Icons.IconSustainability}
                    alt="bg"
                    style={{ width: "70%" }}
                  />
                  <span className="text-[14px] text-[#005D6E] font-bold">
                    Save the planet
                  </span>
                </div>
              </div>
              <ProductInfoPanel
                sections={faqs || []}
                comments={comments}
                specifications={{ title: "Why ENSO?", items: whyEnsoItems }}
              />
            </section>
          )}

          {selectedProduct.name === "Art" && (
            <section className="">
              <div className="bg-[#FFFFFF] text-start md:px-20 px-10 py-10 md:py-0">
                <Breadcrumb items={breadcrumbItems} />
              </div>
              <div className="flex flex-col md:flex-row md:gap-0 gap-5">
                <div className="basis-[50%] md:px-20 px-10 text-start">
                  <div className="flex gap-4 items-center">
                    <div className="flex flex-col gap-4">
                      <div
                        onClick={() => setSelectedView("images")}
                        className="p-4 rounded-full bg-[#75A7AD]"
                        style={{
                          boxShadow: "0px 3px 6px #00000029",
                          backgroundColor:
                            selectedView === "images" ? "#75A7AD" : "#FFFFFF",
                        }}>
                        <BsImages
                          fontSize={25}
                          color={selectedView === "images" ? "white" : "black"}
                        />
                      </div>
                      <div
                        onClick={() => setSelectedView("video")}
                        className="p-4 rounded-full bg-[#FFFFFF]"
                        style={{
                          boxShadow: "0px 3px 6px #00000029",
                          backgroundColor:
                            selectedView === "video" ? "#75A7AD" : "#FFFFFF",
                        }}>
                        <BsPlayCircleFill
                          fontSize={25}
                          color={selectedView === "video" ? "white" : "black"}
                        />
                      </div>
                    </div>
                    <div className="w-full ">
                      {selectedView === "images" ? (
                        <DefaultCarousel
                          images={
                            color === "black"
                              ? selectedProduct.images_black
                              : selectedProduct.images_white
                          }
                        />
                      ) : (
                        <PlainVideo
                          height="420"
                          video={selectedProduct.video || ""}
                        />
                      )}
                      {/* <p className='text-[#005D6E] text-extrabold text-center'>1 out of 6</p> */}
                    </div>
                  </div>
                </div>
                <div
                  className="basis-[50%] text-start md:px-20 px-10 
                flex flex-col gap-4 text-[#005D6E]">
                  <div className="flex flex-col gap-4">
                    <p className="font-semibold">Select your colour:</p>
                    <div className="flex gap-4 justify-start">
                      <div
                        onClick={(e) => {
                          setColor("white");
                          setIsBlack(false);
                        }}>
                        <RoundedCircleComponent bgColor="white" />
                      </div>
                      <div
                        onClick={(e) => {
                          setColor("black");
                          setIsBlack(true);
                        }}>
                        <RoundedCircleComponent bgColor="black" />
                      </div>
                    </div>
                  </div>
                  <h2 className="text-[30px] font-bold">
                    {capitalizeFirstLetter(selectedProduct.name)}
                  </h2>

                  <h2 className="text-[30px] font-bold">
                    R {selectedProduct.price}
                  </h2>
                  <p className="text-[rgb(0,93,110)] text-[14px] mb-[15px] italic">
                    * Price includes VAT
                  </p>

                  <p className="text-[16px] font-light">
                    {selectedProduct.description}
                  </p>

                  <section className=" gap-2 p-2 flex flex-col md:flex-row py-5">
                    <form className="w-full">
                      {stockLoading ? (
                        <div className="mt-[-10%] inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-[#31526B] text-white">
                          <div className="w-2 h-2 rounded-full bg-white mr-1.5 animate-pulse"></div>
                          Checking stock...
                        </div>
                      ) : (
                        <div
                          className={`inline-flex mb-[15px]  items-center px-2.5 py-1 rounded-full text-xs font-medium ${
                            (availableStock || 0) > 0
                              ? "bg-green-100 text-green-800"
                              : "bg-red-100 text-red-800"
                          }`}>
                          {(availableStock || 0) > 0 ? (
                            <>
                              <span className="w-2 h-2 rounded-full bg-green-500 mr-1.5"></span>{" "}
                              In Stock
                            </>
                          ) : (
                            <>
                              <span className="w-2 h-2 rounded-full bg-red-500 mr-1.5"></span>{" "}
                              Out of Stock
                            </>
                          )}
                        </div>
                      )}
                      <section className="flex md:flex-row flex-col">
                        {(availableStock || 0) <= 0 ? (
                          <Link to="/store-locator">
                            <SecondaryButton
                              className=""
                              label={"Store Locator"}
                            />
                          </Link>
                        ) : (
                          <SecondaryButton
                            label={isInCart ? "View Cart" : "Add to Cart"}
                            onClick={handleAddToCart}
                            icon={isInCart ? <Eye /> : <ShoppingCart />}
                            className=""
                          />
                        )}
                      </section>
                    </form>
                  </section>
                  <div className="flex gap-2 justify-start">
                    <div className="flex flex-col gap-2 text-center items-center basis-[20%]">
                      <img
                        src={
                          "http://res.cloudinary.com/brabenjos/image/upload/v1729853659/sodastream/1729853659431.png"
                        }
                        alt="bottle"
                        style={{ width: "35%" }}
                      />
                      <span className="text-[10px]">
                        Delivered to your door ​
                      </span>
                    </div>

                    <div className="flex flex-col gap-2 text-center items-center basis-[20%]">
                      <img
                        src={Icons.IconCertification}
                        alt="bottle"
                        style={{ width: "35%" }}
                      />
                      <span className="text-[10px]">
                        2 years warranty exclusive to{" "}
                        <Link to={"https://www.sodastream.co.za/"}>
                          Sodastream
                        </Link>
                      </span>
                    </div>
                    <div className="flex flex-col gap-2 text-center items-center basis-[20%]">
                      <img
                        src={Icons.IconCall}
                        alt="bottle"
                        style={{ width: "35%" }}
                      />
                      <span className="text-[10px]">
                        Exceptional Customer Service
                      </span>
                    </div>
                  </div>

                  <div>
                    <p className="font-semibold mt-4">Included in box</p>

                    <div
                      className="rounded-2xl mt-5 overflow-hidden"
                      style={{ boxShadow: "0px 7px 20px #0000001A" }}>
                      <div className="flex border">
                        <div className="basis-[100%] bg-[#EEEAE5] px-10 py-5">
                          <h2 className="text-[24px] font-bold">Starter Kit</h2>
                          {/* <span>Rxxxx.xx Rxxxx.xx</span> */}
                        </div>
                      </div>

                      <div className="grid md:grid-cols-2 grid-cols-1 gap-4 text-[12px] px-10 py-4">
                        <div className="flex gap-2 items-center justify-start">
                          <span className="bg-[#005D6E] text-white px-2 py-1 text-[10px] rounded-full flex items-center justify-center">
                            1X
                          </span>
                          <span>
                            {selectedProduct.name} Sparkling Water Maker
                          </span>
                        </div>
                        <div className="flex gap-2 items-center justify-start">
                          <span className="bg-[#005D6E] text-white px-2 py-1 text-[10px] rounded-full flex items-center justify-center">
                            1X
                          </span>
                          <span>Quick Connect CO2 cylinder</span>
                        </div>
                        <div className="flex gap-2 items-center justify-start">
                          <span className="bg-[#005D6E] text-white px-2 py-1 text-[10px] rounded-full flex items-center justify-center">
                            1X
                          </span>
                          <span>1L Dishwasher Safe, PET bottle</span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="mt-5">
                    {/* <SecondaryButton label='Find it in-store' /> */}
                  </div>
                </div>
              </div>
              {/* Recommendations stuff */}
              <div className="hidden md:flex  md:px-20 px-10 py-10 gap-4 md:flex-row flex-col">
                {recommendations.map((recommendation, index) => (
                  <RecommendationItem
                    key={index}
                    image={recommendation.image}
                    title={recommendation.title}
                  />
                ))}
              </div>
              <div className="md:px-20 px-10 pb-10 pt-5 flex gap-4 md:gap-20 items-center justify-center">
                <div className="flex flex-col gap-2 items-center">
                  <img
                    src={Icons.IconFreshWater}
                    alt="bg"
                    style={{ width: "70%" }}
                  />
                  <span className="text-[14px] text-[#005D6E] font-bold">
                    Stay hydrated
                  </span>
                </div>
                <div className="flex flex-col gap-2 items-center">
                  <img
                    src={Icons.IconHeathier}
                    alt="bg"
                    style={{ width: "70%" }}
                  />
                  <span className="text-[14px] text-[#005D6E] font-bold">
                    Limitless taste
                  </span>
                </div>
                <div className="flex flex-col gap-2 items-center">
                  <img
                    src={Icons.IconSustainability}
                    alt="bg"
                    style={{ width: "70%" }}
                  />
                  <span className="text-[14px] text-[#005D6E] font-bold">
                    Save the planet
                  </span>
                </div>
              </div>
              <ProductInfoPanel
                sections={faqs || []}
                comments={comments}
                specifications={{ title: "Why ART?", items: whyARTItems }}
              />
            </section>
          )}

          {selectedProduct.name === "Terra" && (
            <section>
              <div className="bg-[#FFFFFF] text-start  md:px-20 px-10 py-10 md:py-0">
                <Breadcrumb items={breadcrumbItems} />
              </div>
              <div className="flex flex-col md:flex-row md:gap-0 gap-5">
                <div className="basis-[50%] md:px-20 px-10 text-start">
                  <div className="flex gap-4 items-center">
                    <div className="flex flex-col gap-4">
                      <div
                        onClick={() => setSelectedView("images")}
                        className="p-4 rounded-full bg-[#75A7AD]"
                        style={{
                          boxShadow: "0px 3px 6px #00000029",
                          backgroundColor:
                            selectedView === "images" ? "#75A7AD" : "#FFFFFF",
                        }}>
                        <BsImages
                          fontSize={25}
                          color={selectedView === "images" ? "white" : "black"}
                        />
                      </div>

                      <div
                        onClick={() => setSelectedView("video")}
                        className="p-4 rounded-full bg-[#FFFFFF]"
                        style={{
                          boxShadow: "0px 3px 6px #00000029",
                          backgroundColor:
                            selectedView === "video" ? "#75A7AD" : "#FFFFFF",
                        }}>
                        <BsPlayCircleFill
                          fontSize={25}
                          color={selectedView === "video" ? "white" : "black"}
                        />
                      </div>
                    </div>
                    <div className="w-full">
                      {selectedView === "images" ? (
                        <DefaultCarousel
                          images={
                            color === "black"
                              ? selectedProduct.images_black
                              : selectedProduct.images_white
                          }
                        />
                      ) : (
                        <PlainVideo
                          height="220"
                          video={selectedProduct.video || ""}
                        />
                      )}
                    </div>
                  </div>
                </div>

                <div className="basis-[50%] text-start md:px-20 px-10 flex flex-col gap-4 text-[#005D6E]">
                  <div className="flex flex-col gap-4">
                    <p className="font-semibold">Select your colour:</p>
                    <div className="flex gap-4 justify-start">
                      <div
                        onClick={(e) => {
                          setColor("white");
                          setIsBlack(false);
                        }}>
                        <RoundedCircleComponent bgColor="white" />
                      </div>
                      <div
                        onClick={(e) => {
                          setColor("black");
                          setIsBlack(true);
                        }}>
                        <RoundedCircleComponent bgColor="black" />
                      </div>
                    </div>
                  </div>
                  <h2 className="text-[30px] font-bold">
                    {selectedProduct.name}
                  </h2>
                  <h2 className="text-[30px] font-bold">
                    R {selectedProduct.price}
                  </h2>

                  <p className="text-[rgb(0,93,110)] text-[14px] mb-[15px] italic">
                    * Price includes VAT
                  </p>

                  <p className="text-[16px] font-light">
                    {selectedProduct.description}
                  </p>

                  <form className="w-full">
                    {stockLoading ? (
                      <div className="mt-[-10%]  mb-[15px] inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium bg-[#31526B] text-white">
                        <div className="w-2 h-2 rounded-full bg-white mr-1.5 animate-pulse"></div>
                        Checking stock...
                      </div>
                    ) : (
                      <div
                        className={`inline-flex mt-[8%] items-center px-2.5 py-1 rounded-full text-xs font-medium ${
                          (availableStock || 0) > 0
                            ? "bg-green-100 text-green-800"
                            : "bg-red-100 text-red-800"
                        }`}>
                        {(availableStock || 0) > 0 ? (
                          <>
                            <span className="w-2 h-2 rounded-full bg-green-500 mr-1.5"></span>{" "}
                            In Stock
                          </>
                        ) : (
                          <>
                            <span className="w-2 h-2 rounded-full bg-red-500 mr-1.5"></span>{" "}
                            Out of Stock
                          </>
                        )}
                      </div>
                    )}
                  </form>

                  <section className="flex md:flex-row flex-col">
                    {(availableStock || 0) <= 0 ? (
                      <Link to="/store-locator">
                        <SecondaryButton label={"Store Locator"} />
                      </Link>
                    ) : (
                      <SecondaryButton
                        label={isInCart ? "View Cart" : "Add to Cart"}
                        onClick={handleAddToCart}
                        icon={isInCart ? <Eye /> : <ShoppingCart />}
                        className=""
                      />
                    )}
                  </section>

                  {/* <p className='text-[12px] font-light'>The Terra features a retro design along with a unique carbonating lever.</p> */}
                  <div className="flex gap-2 justify-start">
                    <div className="flex flex-col gap-2 text-center items-center basis-[20%]">
                      <img
                        src={
                          "http://res.cloudinary.com/brabenjos/image/upload/v1729853659/sodastream/1729853659431.png"
                        }
                        alt="bottle"
                        style={{ width: "35%" }}
                      />
                      <span className="text-[10px]">
                        Delivered to your door ​
                      </span>
                    </div>

                    <div className="flex flex-col gap-2 text-center items-center basis-[20%]">
                      <img
                        src={Icons.IconCertification}
                        alt="bottle"
                        style={{ width: "35%" }}
                      />
                      <span className="text-[10px]">
                        2 years warranty exclusive to{" "}
                        <Link to={"https://www.sodastream.co.za/"}>
                          Sodastream
                        </Link>
                      </span>
                    </div>
                    <div className="flex flex-col gap-2 text-center items-center basis-[20%]">
                      <img
                        src={Icons.IconCall}
                        alt="bottle"
                        style={{ width: "35%" }}
                      />
                      <span className="text-[10px]">
                        Exceptional Customer Service
                      </span>
                    </div>
                  </div>

                  <div>
                    <p className="font-semibold">Included in box</p>

                    <div
                      className="rounded-2xl mt-5 overflow-hidden"
                      style={{ boxShadow: "0px 7px 20px #0000001A" }}>
                      <div className="flex border">
                        <div className="basis-[100%] bg-[#EEEAE5] px-10 py-5">
                          <h2 className="text-[24px] font-bold">Starter Kit</h2>
                          {/* <span>Rxxxx.xx Rxxxx.xx</span> */}
                        </div>
                      </div>

                      <div className="grid md:grid-cols-2 grid-cols-1 gap-4 text-[12px] px-10 py-4">
                        <div className="flex gap-2 items-center justify-start">
                          <span className="bg-[#005D6E] text-white px-2 py-1 text-[10px] rounded-full flex items-center justify-center">
                            1X
                          </span>
                          <span>Terra Sparkling Water Maker</span>
                        </div>
                        <div className="flex gap-2 items-center justify-start">
                          <span className="bg-[#005D6E] text-white px-2 py-1 text-[10px] rounded-full flex items-center justify-center">
                            1X
                          </span>
                          <span>Quick Connect CO2 cylinder</span>
                        </div>
                        <div className="flex gap-2 items-center justify-start">
                          <span className="bg-[#005D6E] text-white px-2 py-1 text-[10px] rounded-full flex items-center justify-center">
                            1X
                          </span>
                          <span>1L PET bottles</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="md:px-20 px-10 py-10 flex gap-4 md:flex-row flex-col"></div>

              <div className="md:px-20 px-10 pb-10 pt-5 flex gap-4 md:gap-20 items-center justify-center">
                <div className="flex flex-col gap-2 items-center">
                  <img
                    src={Icons.IconFreshWater}
                    alt="bg"
                    style={{ width: "70%" }}
                  />
                  <span className="text-[14px] text-[#005D6E] font-bold">
                    Stay hydrated
                  </span>
                </div>
                <div className="flex flex-col gap-2 items-center">
                  <img
                    src={Icons.IconHeathier}
                    alt="bg"
                    style={{ width: "70%" }}
                  />
                  <span className="text-[14px] text-[#005D6E] font-bold">
                    Limitless taste
                  </span>
                </div>
                <div className="flex flex-col gap-2 items-center">
                  <img
                    src={Icons.IconSustainability}
                    alt="bg"
                    style={{ width: "70%" }}
                  />
                  <span className="text-[14px] text-[#005D6E] font-bold">
                    Save the planet
                  </span>
                </div>
              </div>
              <ProductInfoPanel
                sections={faqs || []}
                comments={comments}
                specifications={{ title: "Why Terra?", items: whyTerraItems }}
              />
            </section>
          )}

          <CartModal
            isCartModalVisible={isCartModalVisible}
            setIsCartModalVisible={setIsCartModalVisible}
            addedProduct={selectedproductColor}
            handleDecrease={handleProductDecrease}
            handleIncrease={handleProductIncrease}
            availableStock={availableStock}
            quantity={0}
            isUpdating={isUpdating}
            isDecreasing={isDecreasing}
            isBlack={isBlack}
            isMachine={true}
          />
          <Footer />
        </div>
      ) : (
        <Loading />
      )}
    </div>
  );
};
export default WaterMakerProductPage;
